export const AdminUserListConstants = {
    StoreSliceName: 'AdminUserList',
};
